import { useTheme } from 'antd-style'

import { OcrHelpProps } from './interface'

export const OCrHelp = ({ className, style, title, limit }: OcrHelpProps) => {
  const theme = useTheme()

  return (
    <div className={className} style={style}>
      <span>{title}</span>
      <span>，今日剩余识别次数&nbsp;</span>
      <span style={{ color: theme.yellow }}>
        {limit.rest}/{limit.total}
      </span>
    </div>
  )
}
